import React from "react";
import styles from "./Style.module.css";
// import DashboardSnackbar from "../../../components/Snackbar.component";
import classNames from "classnames";
import logoImage from "../../../src/assets/CRMAssets/psconnect_sidebar_updated.png";
import { IconButton, ButtonBase, Typography, Button, CircularProgress } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomTextField from "../../../src/components/FormFields/TextField/TextField.component";
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import useLoginDietitianHook from "./LoginDietitian.hook";
import { ArrowPrimaryButton } from "../../components/Buttons/PrimaryButton";
import PhoneNo from "../../views/LoginDietitian/Component/Phone";
import SnackbarUtils from "../../libs/SnackbarUtils";
import DashboardSnackbar from "../../components/Snackbar.component";

function LoginDietitian() {
    const theme = useTheme();
    const { domainTheme } = useSelector((state) => state.app_setting || {});
    const cachedTheme = !domainTheme ? (() => {
        try {
            const currentDomain = (typeof window !== 'undefined' && window.location.hostname) ? window.location.hostname : '';
            const domainKey = currentDomain ? `client_theme_${currentDomain}` : null;
            return JSON.parse((domainKey && localStorage.getItem(domainKey)) || localStorage.getItem('domain_theme_data') || localStorage.getItem('domainTheme') || '{}');
        } catch (e) {
            return {};
        }
    })() : null;
    const activeTheme = domainTheme || cachedTheme || {};

    const logoUrl = activeTheme.display_logo || activeTheme.logo || activeTheme.logo_url || logoImage;
    const bgUrl = activeTheme.background_image || activeTheme.login_background || activeTheme.bg_image;

    const {
        handleSubmit,
        onBlurHandler,
        changeTextData,
        form,
        errorData,
        isSubmitting
    } = useLoginDietitianHook();

    return (
        <div className={"login"} id="loginview">
            <div
                className={styles.overlay}
                style={bgUrl ? { display: "none" } : {}}
            />
            <div
                className={styles.mainLoginView}
                style={bgUrl ? {
                    backgroundImage: `url(${bgUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                } : {}}
            />
            <div className={styles.container}>
                <div className={styles.loginFlex2}>
                    <div className={styles.logoImageData}>
                        <img
                            src={logoUrl}
                            alt="logo"
                            style={{ width: "250px", height: "80px", objectFit: "contain" }}
                            onError={(e) => { e.target.onerror = null; e.target.src = logoImage; }}
                        />
                    </div>
                    <div className={styles.signContainer}>
                        <div className={styles.loginHeaderText}>
                            <Typography variant="h3">Dietitian Login</Typography>

                            <Typography
                                variant={"body1"}
                                sx={{ color: theme?.palette?.text?.secondary }}
                            >
                                Please enter your phone number to login
                            </Typography>
                        </div>

                        <div className={styles.formContainer}>
                            <div className={styles.formFlexGrouup}>
                                <div className={"formGroup"}>
                                    <PhoneNo
                                        errorData={errorData}
                                        form={form}
                                        changeTextData={changeTextData}
                                    // isSubmitting={isSubmitting}
                                    // isPhoneDisabled={isPhoneDisabled}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className={styles.loginAction}>
                            <Button
                                variant={"h6"}
                                onClick={() => handleSubmit()}
                            >
                                {isSubmitting ? (
                                    <CircularProgress size={24} color={"primary"} />
                                ) : (
                                    "LOGIN"
                                )}
                            </Button>


                        </div>

                    </div>
                </div>

            </div>
            <DashboardSnackbar />
        </div>
    );
}

export default LoginDietitian;
